export const getUICompanyName = (draft)=>{
    var _draft_contactDetails;
    return draft.isSample ? 'Anchor (Sample)' : ((_draft_contactDetails = draft.contactDetails) === null || _draft_contactDetails === void 0 ? void 0 : _draft_contactDetails.companyName) || '';
};
